import locale from "localization/en";
import styles from "../dry-stock.module.scss";
import { initialShiftRecordFilterState } from "modules/records/shift-records/shift-records-filter.state";
import { Title } from "components/commons";
import useDataTable from "hooks/useDataTable";
import DataTableV2 from "components/commons/data-table/data-table-v2";
import { dryStockDeliveriesMapper, dryStockDeliveryProductsMapper } from "./deliveries.mapper";
import { dryStockDeliveriesColumn, dryStockDeliveryProductsColumn } from "./deliveries-column";

const DryStockDeliveries = ({ shift, allProducts }) => {
  const dryStockDeliveries = shift?.delivery.deliveries?.filter(
    (delivery) => delivery.productType !== "fuel"
  );

  const dryStockDeliveriesDataTable = useDataTable({
    value: dryStockDeliveries,
    filter: { initialState: initialShiftRecordFilterState(), mapper: (val) => val },
    table: {
      key: "delivery",
      name: "dryStockDeliveries",
      mapper: (val) => dryStockDeliveriesMapper({ val }),
      columns: dryStockDeliveriesColumn,
    },
  });

  const formattedDeliveryProducts = shift?.delivery.deliveryProducts
    ?.map((delivery) => {
      const product = allProducts.find(
        (item) =>
          item.sku.toLowerCase().replace(/\s+/g, "") ===
          delivery.product.toLowerCase().replace(/\s+/g, "")
      );

      return {
        ...delivery,
        sku: delivery.product || "-",
        type: product?.type,
        product: product?.name || "-",
        variant: product?.variant || "-",
      };
    })
    .filter((delivery) => delivery.type !== "fuel")
    ?.sort((a, b) => {
      if (a.deliveryId === b.deliveryId) {
        return a.product.localeCompare(b.product);
      }

      return 0;
    });

  const dryStockDeliveryProductsDataTable = useDataTable({
    value: formattedDeliveryProducts,
    filter: { initialState: initialShiftRecordFilterState(), mapper: (val) => val },
    table: {
      key: "delivery",
      name: "dryStockDeliveryProducts",
      mapper: (val) => dryStockDeliveryProductsMapper({ val }),
      columns: dryStockDeliveryProductsColumn,
    },
  });

  return (
    <>
      <Title small black>
        {locale.dryStockDeliveries}
      </Title>
      <div className={styles.spacer10} />
      <div className={styles.tableContainer}>
        <DataTableV2
          {...dryStockDeliveriesDataTable.table}
          hideNoSearchResultRender
          tableVersion="v2"
          hidePagination
        />
      </div>
      <div className={styles.spacer10} />
      <div className={styles.tableContainer}>
        <DataTableV2
          {...dryStockDeliveryProductsDataTable.table}
          hideNoSearchResultRender
          tableVersion="v2"
          hidePagination
        />
      </div>
      <div className={styles.spacer50} />
    </>
  );
};

export default DryStockDeliveries;
